import { render, staticRenderFns } from "./addOption.vue?vue&type=template&id=32c564d4"
import script from "./addOption.vue?vue&type=script&lang=js"
export * from "./addOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports